import type { Brand } from '@snapchat/mw-common';
import { allBrands, Site, SitesToBrands } from '@snapchat/mw-common';
import { useContext } from 'react';

import { AppContext } from '../AppContext';
import { Config } from '../config';
import { UrlParameter } from '../constants/urlParameters';

/**
 * Resolves the current brand for the site.
 *
 * On sandbox, the `alternateMotif` query param can override the brand. If the param contains a
 * valid brand, it takes precedence over the static site brand from `SitesToBrands`.
 */
export function useBrand(): Brand | undefined {
  const { getCurrentUrl } = useContext(AppContext);

  let brand = SitesToBrands[Config.site];

  if (Config.site === Site.SANDBOX) {
    const url = new URL(getCurrentUrl());
    const alternateMotif = url.searchParams.get(UrlParameter.USE_ALTERNATE_MOTIF);

    const isValidBrand = alternateMotif && allBrands.includes(alternateMotif as Brand);

    if (isValidBrand) {
      brand = alternateMotif as Brand;
    }
  }

  return brand;
}
